<template>
    <b-col md="6" lg="6" xl="4"
            @click.stop="$emit('onClicked', campaign)">
        <div class="campaign-item-container pointer box-shadow mb-4">
            <div class="campaign-item-pic" v-bind:style="{ backgroundImage: 'url(' + getImageUrl() + ')' }">
                <transition name="fade">
                    <div v-if="!backgroundImageLoaded" class="header-img-overlay">
                    </div>
                </transition>
                <small-member-item v-if="campaign.user"
                                   :member="campaign.user">
                </small-member-item>
                <div
                        v-if="canEdit()"
                        class="round-btn top-right" @click.stop="$emit('edit',campaign)">
                    <font-awesome-icon icon="pencil-alt"/>
                </div>
            </div>
            <div class="m-3">
                <b-col md="12" class="pt-1 campaign-item-organization">
                    <b-row>
                        <b-col>
                            <h3 class="info-subtitle palette-primary campaign-header">{{ campaign.organization.name }}</h3>
                            <div class="col-12 note" v-if="campaignEnded()">{{
                                    $t('campaign.campaign_ended')
                                }}
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="pt-2 campaign-item-name">
                    <b-row>
                        <b-col>
                            <h4 class="campaign-header">{{ campaign.name }}</h4>
                            <div class="col-12 note" v-if="campaignEnded()">{{
                                    $t('campaign.campaign_ended')
                                }}
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="12" class="campaign-item-team">
                    <b-row>
                        <b-col>
                            <h4 class="campaign-header">{{ campaign.team ? campaign.team.name : "" }}</h4>
                            <div class="col-12 note" v-if="campaignEnded()">{{
                                    $t('campaign.campaign_ended')
                                }}
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="12" class="campaign-item-license">
                    <b-row>
                        <b-col>
                            <h6>{{ $t('campaign.license') }}
                                {{ campaign.organization.license ? campaign.organization.license : '-' }}</h6>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="12" class="text-center campaign-item-donate p-3">
                    <b-button
                            v-if="showDonate"
                            @click.stop="$emit('donate', campaign)"
                            variant="outline-info fair-button-outline"
                            class="campaign_donate_button">
                        {{ $t('campaign.donate') }}
                    </b-button>
                </b-col>
            </div>
        </div>
    </b-col>
</template>

<script>
    import {timeMixin} from "../../mixins/TimeMixin";
    import FairApi from "../../modules/api";
    import SmallMemberItem from "../member/SmallMemberItem";

    export default {
        name: "campaign-item",
        components: {SmallMemberItem},
        mixins: [timeMixin],
        props: {
            campaign: {
                type: Object,
                default: null
            },
            showDonate: {
                type: Boolean,
                default: function () {
                    return true
                }
            },
            editable: {
                type: Boolean,
                default: function () {
                    return false
                }
            }
        },

        data() {
            return {
                photo: '',
                backgroundImageLoaded: false
            }
        },

        created() {
            this.fetchPhoto()
        },

        methods: {
            getImageUrl() {
                return this.photo
            },

            fetchPhoto() {
                if (this.campaign.photo) {
                    FairApi.get(FairApi.photo(this.campaign.photo.id), this.success, function () {
                    })
                }
            },

            success(response) {
                this.photo = response
                this.backgroundImageLoaded = true
                this.$emit('onLoaded')
            },

            canEdit: function () {
                return this.editable && this.campaign.active && this.$store.state.user.organization &&
                    this.$store.state.user.organization.id === this.campaign.organization.id
            },

            campaignEnded() {
                return this.campaign.active !== true || this.isDatePassed(this.campaign.endDate);
            }
        }
    }
</script>

<style scoped>
.campaign-header {
    white-space: wrap;
    word-break: normal;
    text-overflow: ellipsis;
    overflow: hidden;
}
</style>